/**
 * Generated bundle index. Do not edit.
 */

export * from './chrome.component';

export {ChromeFieldsComponent as ɵa} from './chrome-fields.component';